// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__24gp6","header":"MergedInvoice_header__1ZbVN"};